import { Link } from "react-router-dom";
import { Trophy, ArrowRight } from "lucide-react";
import { RACING_IMAGES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const RacingBrand = () => (
  <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-testid="racing-brand">
    <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
      <Reveal>
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-xmove-orange">
          <Trophy size={15} /> Chi siamo dietro XMOVE
        </p>
        <h2 className="mt-3 font-display text-3xl font-bold text-xmove-ink sm:text-4xl">
          La stessa ossessione dei box. Applicata al tuo contratto.
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-xmove-muted">
          XMOVE nasce da una passione vera per i motori: siamo sponsor nel campionato
          Lamborghini Super Trofeo e portiamo in pista il nostro nome ogni weekend di gara.
          È lì che abbiamo imparato che i dettagli fanno la differenza — e li applichiamo
          a ogni preventivo, ogni pratica, ogni consegna.
        </p>
        <Link
          to="/chi-siamo/"
          data-testid="racing-chi-siamo-link"
          className="mt-7 inline-flex items-center gap-2 font-display text-sm font-bold text-xmove-orange transition-colors hover:text-xmove-orangeDark"
        >
          Scopri la nostra storia <ArrowRight size={16} />
        </Link>
      </Reveal>
      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        <Reveal className="col-span-2">
          <img
            src="/images/racing-track.webp"
            alt="Lamborghini Super Trofeo XMOVE #252 in azione in pista"
            loading="lazy"
            className="aspect-[16/11] w-full rounded-2xl object-cover shadow-lift sm:aspect-[16/9]"
          />
        </Reveal>
        <Reveal delay={0.1} className="hidden sm:block">
          <img
            src={RACING_IMAGES[1]}
            alt="Dettaglio vettura da corsa sponsorizzata XMOVE"
            loading="lazy"
            className="aspect-square w-full rounded-2xl object-cover shadow-soft"
          />
        </Reveal>
        <Reveal delay={0.18} className="hidden sm:block">
          <img
            src={RACING_IMAGES[2]}
            alt="Azione in circuito Lamborghini Super Trofeo"
            loading="lazy"
            className="aspect-square w-full rounded-2xl object-cover shadow-soft"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
